var map = {
	"./birth_watch_logo_header.svg": 3690,
	"./birth_watch_sidenav_logo.svg": 4498,
	"./bluecherry_logo_header.svg": 1819,
	"./bluecherry_sidenav_logo.svg": 6648,
	"./came_logo_header.png": 4038,
	"./came_logo_sidenav.png": 1288,
	"./dbmatic_logo_header.svg": 5612,
	"./dbmatic_sidenav_logo.svg": 5820,
	"./duotecno_logo_header.jpg": 1087,
	"./duotecno_sidenav_logo.jpg": 3736,
	"./farra_connect_logo_header.svg": 4485,
	"./farra_connect_sidenav_logo.png": 3187,
	"./farra_connect_sidenav_logo.svg": 12,
	"./logo.svg": 2835,
	"./logo_backup.svg": 2848,
	"./rovin_logo.svg": 9574,
	"./stripe.png": 3288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;